<template>
    <div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="用户信息" name="first">
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">微信昵称</el-col>
                    <el-col :span="8">{{ seller ? seller.nickname : "" }}</el-col>
                    <el-col :span="4">用户头像</el-col>
                    <el-col :span="8">
                        <el-avatar size="small" :src="seller ? seller.headPic : defaultHeadPicSrc"></el-avatar>
                    </el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">APPID</el-col>
                    <el-col :span="8"></el-col>
                    <el-col :span="4">注册时间</el-col>
                    <el-col :span="8">{{ seller ? dateFormatter(null, null, seller.registDate) : "" }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">手机号</el-col>
                    <el-col :span="8">{{ seller ? seller.phone : "" }}</el-col>
                    <el-col :span="4">姓名</el-col>
                    <el-col :span="8">{{ seller.sellerName }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">生日</el-col>
                    <el-col :span="8">{{
                            seller ? dateFormatter(null, null, seller.birthday) : ""
                    }}</el-col>
                    <el-col :span="4">性别</el-col>
                    <el-col :span="8">{{
                            seller ? (seller.sex == "2" ? "女" : "男") : ""
                    }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">邮箱</el-col>
                    <el-col :span="8">{{ seller ? seller.email : "" }}</el-col>
                    <el-col :span="4">身份证</el-col>
                    <el-col :span="8">{{ seller ? seller.idCard : "" }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">身份证有效期</el-col>
                    <el-col :span="8">{{
                            seller.realnameValid ? seller.realnameValid.validdata : ""
                    }}</el-col>
                    <el-col :span="4">核验图片</el-col>
                    <el-col :span="8">
                        <img v-if="seller.realnameValid" :src="seller.realnameValid.handPic"
                            style="width: 80px; height: auto" />
                    </el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">联系地址</el-col>
                    <el-col :span="20">{{ seller.address }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">所在单位</el-col>
                    <el-col :span="8">{{ seller.company }}</el-col>
                    <el-col :span="4">用户等级</el-col>
                    <el-col :span="8">{{ seller.creditLevelName }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">银行卡户名</el-col>
                    <el-col :span="8">{{
                            seller && seller.accountinfo ? seller.accountinfo.bankAccount : ""
                    }}</el-col>
                    <el-col :span="4">账号</el-col>
                    <el-col :span="8">{{
                            seller && seller.accountinfo ? seller.accountinfo.bankCardNum : ""
                    }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">开户行</el-col>
                    <el-col :span="8">{{
                            seller && seller.accountinfo ? seller.accountinfo.bankName : ""
                    }}</el-col>
                    <el-col :span="4">网点</el-col>
                    <el-col :span="8"></el-col>
                </el-row>
                <!-- <el-row :gutter="24" style="display: flex">
            <el-col :span="4">支付宝户名</el-col>
            <el-col :span="8"></el-col>
            <el-col :span="4">账号</el-col>
            <el-col :span="8"></el-col>
          </el-row> -->
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">推荐人手机</el-col>
                    <el-col :span="8">{{ seller.referPhone }}</el-col>
                    <el-col :span="4">用户来源</el-col>
                    <el-col :span="8">{{ seller ? seller.source : "" }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">推荐人</el-col>
                    <el-col :span="20">{{ seller.referrer }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">自定义等级</el-col>
                    <el-col :span="8">{{ seller.disability }}</el-col>
                    <el-col :span="4">婚姻状况</el-col>
                    <el-col :span="8">{{ seller.marriage == '0' ? '未婚' : '已婚' }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">监护人</el-col>
                    <el-col :span="8">{{ seller.guarder }}</el-col>
                    <el-col :span="4">监护人手机</el-col>
                    <el-col :span="8">{{ seller.guarderPhone }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: none">
                    <el-col :span="4">个人介绍</el-col>
                    <el-col :span="20">{{
                            seller ? seller.selfIntroduction : ""
                    }}</el-col>
                </el-row>
                <el-row :gutter="24" style="display: flex">
                    <el-col :span="4">备注信息</el-col>
                    <el-col :span="20">{{
                            seller ? seller.notes : ""
                    }}</el-col>
                </el-row>
                <!-- <el-row :gutter="24" style="display: flex">
            <el-col :span="24"> <h4>自定义字段</h4></el-col>
          </el-row> -->
            </el-tab-pane>
            <el-tab-pane label="出售订单" name="second">
                <el-row :gutter="24">
                    <el-col :span="6">累计出售数量:</el-col>
                    <el-col :span="6">{{ orderInfo.obj.numCount }}</el-col>
                    <el-col :span="6">累计出售金额:</el-col>
                    <el-col :span="6">{{ orderInfo.obj.moneyCount }}元</el-col>
                </el-row>
                <common-table ref="orderInfo" :singleSelect="true" method="get" :searchForm="orderInfo.params"
                    :api="orderInfo.api" :column="orderInfo.column" :key="orderInfo.params.sellerId"
                    :callback="orderInfo.callback">
                </common-table>
            </el-tab-pane>
            <el-tab-pane label="信用积分" name="third">
                <el-row :gutter="24">
                    <el-col :span="8">累计信用积分:</el-col>
                    <el-col :span="4">
                        {{ creditInfo.obj.creditTotal }}
                        <el-button @click.native.prevent="changeCreditPoint()" type="text" size="small">
                            修改
                        </el-button>
                    </el-col>
                    <el-col :span="6">信用等级:</el-col>
                    <el-col :span="6">{{ creditInfo.obj.creditLevelName }}</el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="8">累计免审信用额（元）:</el-col>
                    <el-col :span="4">{{ creditInfo.obj.creditLimitTotal }}</el-col>
                    <el-col :span="12" style="color: #999">备注：累计免审信用额=系统信用额+人工调整额</el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="8">系统信用额度（元）:</el-col>
                    <el-col :span="4">{{ creditInfo.obj.creditLimitSys }}</el-col>
                    <el-col :span="6">人工调整额（元）:</el-col>
                    <el-col :span="6">
                        <span v-if="!changeLimitHandFlag">{{
                                creditInfo.obj.creditLimitHand
                        }}</span>
                        <el-input v-if="changeLimitHandFlag" v-model="creditInfo.obj.creditLimitHand"
                            placeholder="请输入内容">
                        </el-input>
                        <el-button v-if="!changeLimitHandFlag"
                            @click.native.prevent="changeCreditLimitHand(creditInfo.obj.id)" type="text" size="small">
                            修改
                        </el-button>
                        <el-button v-if="changeLimitHandFlag" @click.native.prevent="
                            changeCreditLimitHandSure(creditInfo.obj.id)
                        " type="text" size="small">
                            保存
                        </el-button>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="8">剩余可用额度（元）:</el-col>
                    <el-col :span="4">{{ creditInfo.obj.creditLimitSurplus }}</el-col>
                </el-row>
                <common-table ref="creditInfo" :singleSelect="true" :postQuery="creditInfo.params" :api="creditInfo.api"
                    :column="creditInfo.column" :key="creditInfo.params.id" :callback="creditInfo.callback">
                </common-table>
            </el-tab-pane>
            <el-tab-pane label="提现记录" name="fourth">
                <el-row :gutter="20">
                    <el-col :span="8">累计已提现（元）:</el-col>
                    <el-col :span="4">{{
                            (payLimit.limitTotal / 100).toFixed(2)
                    }}</el-col>
                    <el-col :span="8">每日提现开关:</el-col>
                    <el-col :span="4">
                        <el-switch v-model="payLimit.isWork" @change="changePayLimitWork(payLimit.isWork)"
                            active-color="#13ce66" :inactive-value="'0'" :active-value="'1'" inactive-color="#ff4949">
                        </el-switch>
                    </el-col>
                    <el-col :span="8">日提现总限额:</el-col>
                    <el-col :span="4">
                        {{ payLimit.dailyLimit }}
                        <el-button type="text" @click="handleChangePayLimit">修改</el-button>
                    </el-col>
                    <el-col :span="8">当日已提现额度:</el-col>
                    <el-col :span="4">{{
                            (payLimit.dailyLimitUsed / 100).toFixed(2)
                    }}</el-col>
                </el-row>
                <common-table ref="walletList" :singleSelect="true" method="get" :searchForm="walletList.params"
                    :api="walletList.api" :column="walletList.column" :key="walletList.params.sellerId"
                    :callback="walletList.callback">
                </common-table>
            </el-tab-pane>
            <el-tab-pane label="会员付费" name="five">
                <el-row>
                    <el-col :span="10">
                        付费会员有效期：{{ vipPayMounthTableData.maxDate }}
                    </el-col>
                    <el-col :span="14">
                        人工调整额（天）：
                        <el-input-number size="mini" v-model="vipPayMounthTableData.vipMonth" :precision="0" style="width:120px" />
                        <el-link type="primary" @click="modifyValidate">提交</el-link>
                    </el-col>
                </el-row>
                <common-table ref="vipPayMounthTableData" :singleSelect="true"
                    :searchForm="vipPayMounthTableData.params" :api="vipPayMounthTableData.api"
                    :column="vipPayMounthTableData.column" :key="vipPayMounthTableData.params.sellerId"
                    :callback="vipPayMounthTableData.callback">
                </common-table>
            </el-tab-pane>
            <el-tab-pane label="购买订单" name="sex">
                <common-table ref="vipPayTableData" :singleSelect="true" :searchForm="vipPayTableData.params"
                    :api="vipPayTableData.api" :column="vipPayTableData.column" :key="vipPayTableData.params.sellerId"
                    :callback="vipPayTableData.callback">
                </common-table>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="修改用户积分" append-to-body :visible.sync="showChangePoint" width="50%">
            <el-input-number v-model="changePoint" label="请输入修改积分，整数为加负数为减"></el-input-number>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeChangePoint()">取 消</el-button>
                <el-button type="primary" @click="saveChangePoint">保 存</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改用户每日提现限额" append-to-body :visible.sync="showChangePayLimit" width="50%">
            <el-input-number v-model="payLimit.dailyLimit" label="请输入每日提现限额"></el-input-number>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeChangePayLimit()">取 消</el-button>
                <el-button type="primary" @click="saveChangePayLimit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import utils from "../../utils/utils";
export default {
    props: {
        seller: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            vipPayMounthTableData: {
                api: "/api/order/queryMemberOrder",
                params: { sellerId: 0 },
                vipMonth: '',
                maxDate: '',
                callback: (res, data) => {
                    if(res.data.obj){
                        this.vipPayMounthTableData.maxDate = utils.dateFormat(res.data.obj, 'yyyy-MM-dd')
                    }
                    data.forEach(i=>{
                        i.addedDate = utils.dateFormat(i.addedDate, 'yyyy-MM-dd')
                        i.modDate = utils.dateFormat(i.modDate)
                    })
                },
                column: [
                    { label: "有效期增加(天)", name: "addDay" },
                    { label: "变动后有效期截至", name: "addedDate" },
                    { label: "变动时间", name: "modDate" },
                    { label: "变动类型", name: "type" },
                ],
            },
            vipPayTableData: {
                api: "/api/order/queryArticleOrder",
                params: { sellerName: '', sellerId: 0 },
                callback: (res, data) => {
                    data.forEach(element => {
                        element.statusName = element.status;
                        element.createTime = utils.dateFormat(
                            element.createTime,
                            "yyyy-MM-dd HH:mm:ss"
                        );
                        this.statusObj.forEach((item) => {
                            if (item.status == element.status && element.status != 0) {
                                element.statusName = item.name;
                            }
                        });
                    })
                },
                column: [
                    { label: "订单号", name: "orderNum" },
                    { label: "文章标题", name: "cardName" },
                    { label: "金额(元)", name: "actualPay" },
                    { label: "退款金额", name: "refundMoney" },
                    { label: "订单状态", name: "status" },
                    { label: "下单时间", name: "createTime" },
                    { label: "退款时间", name: "refundTime" },
                ],
            },
            statusObj: [
                { status: "0", name: "全部", showTab: true },
                { status: "4", name: "待支付", showTab: false },
                { status: "10", name: "已退款", showTab: true },
                { status: "6", name: "已完成", showTab: true },
            ],
            creditInfo: {
                api: "/api/seller/getCreditInfo",
                params: { id: 0 },
                callback: (res, data) => {
                    this.creditInfo.obj = res.data.obj
                },
                column: [
                    { label: "项目", name: "ruleWorkWay" },
                    { label: "时间", name: "getTime", formatter: this.dateFormatter },
                    { label: "信用积分变动", name: "creditChange" },
                    { label: "累计积分", name: "totalCredits" },
                ],
                obj: {
                    id: null,
                    creditLevelName: "",
                    creditLimitHand: 0,
                    creditLimitSurplus: 0,
                    creditLimitSys: 0,
                    creditLimitTotal: 0,
                    creditTotal: 0,
                },
            },
            orderInfo: {
                api: "/api/order/queryOrderBySellerId",
                params: { sellerId: 0 },
                callback: (res, data) => {
                    this.orderInfo.obj = res.data.obj;
                },
                obj: {
                    numCount: 0,
                    moneyCount: 0,
                },
                column: [
                    { label: "订单号", name: "orderNum" },
                    { label: "商品名称", name: "cardName" },
                    { label: "金额（元）", name: "payMoney", width: 80 },
                    { label: "实际金额（元）", name: "actualPay" },
                    { label: "下单时间", name: "createTime", formatter: this.dateFormatter },
                    { label: "订单状态", name: "status" },
                ],
            },
            walletList: {
                api: "/api/shop/getTransfersRecordBySellerId",
                params: { sellerId: 0 },
                callback: (res, data) => {
                    data.forEach(d => {
                        d.amount = (d.amount / 100).toFixed(2)
                    })
                },
                column: [
                    { label: "提现金额", name: "amount" },
                    { label: "提现时间", name: "paymentTime" },
                    { label: "微信付款单号", name: "paymentNo" },
                    { label: "商户订单号", name: "partnerTradeNo" },
                ],
            },
            activeName: "first",
            payLimit: {
                isWork: "0",
                limitTotal: 0,
                dailyLimit: 100,
                dailyLimitUsed: 100,
            },
            showChangePoint: false,
            changePoint: null,
            showChangePayLimit: false,
            changeLimitHandFlag: false,
        }
    },
    created() {
        this.orderInfo.params.sellerId = this.seller.id
        this.walletList.params.sellerId = this.seller.id
        this.vipPayMounthTableData.params.sellerId = this.seller.id
        this.creditInfo.params.id = this.seller.id
        this.vipPayTableData.params.sellerName = this.seller.nickname
        this.vipPayTableData.params.sellerId = this.seller.id
        this.activeName = "first"
        this.$httpRequest.get("/api/seller/getSellerPayLimit", { sellerId: this.seller.id })
            .then((res) => {
                this.payLimit = res.data.obj;
            })
            .catch((e) => {
                console.log(e);
            });
    },
    methods: {

        handleChangePayLimit() {
            this.showChangePayLimit = true;
        },
        // 手动修改用户积分
        changeCreditPoint() {
            this.showChangePoint = true;
        },
        closeChangePoint() {
            this.showChangePoint = false;
        },
        closeChangePayLimit() {
            this.showChangePayLimit = false;
        },
        handleTabClick() { },
        // 日期格式化
        dateFormatter(row, column, cellValue, index, format) {
            return utils.dateFormat(cellValue, format);
        },
        saveChangePayLimit() {
            utils.axiosMethods({
                method: "GET",
                url: "/api/seller/insertDailyLimit",
                params: {
                    sellerId: this.seller.id,
                    limit: this.payLimit.dailyLimit,
                },
                callback: (res) => {
                    this.showChangePayLimit = false;
                    this.viewDialogVisible = false;
                    this.$message({
                        message: "修改成功",
                        type: "success",
                    });
                },
            });
        },
        saveChangePoint() {
            utils.axiosMethods({
                method: "GET",
                url: "/api/seller/insertCreditPoint",
                params: {
                    sellerId: this.seller.id,
                    point: this.changePoint,
                },
                callback: (res) => {
                    this.showChangePoint = false;
                    this.$message({
                        message: "修改成功",
                        type: "success",
                    });
                },
            });
        },
        // 手动修改额度
        changeCreditLimitHand(id) {
            this.changeLimitHandFlag = true;
        },
        //手动修改额度保存
        changeCreditLimitHandSure(id) {
            utils.axiosMethods({
                method: "POST",
                url: "/api/seller/changeCreditLimitHand",
                params: {
                    id: id,
                    creditNum: this.creditInfo.obj.creditLimitHand,
                },
                callback: (res) => {
                    this.changeLimitHandFlag = false;
                    this.creditInfo.obj.creditLimitTotal =
                        parseFloat(this.creditInfo.obj.creditLimitHand) +
                        parseFloat(this.creditInfo.obj.creditLimitSys);
                    this.$message({
                        message: "恭喜你，修改成功",
                        type: "success",
                    });
                },
            });
        },
        changePayLimitWork(val) {
            const isWork = val ? "1" : "0";
            utils.axiosMethods({
                method: "GET",
                url: "/api/seller/changeSellerPayLimitWork",
                params: {
                    sellerId: this.seller.id,
                    isWork: isWork,
                },
                callback: (res) => {
                    if (res.data.code == 0) {
                        this.$message({
                            message: "修改成功",
                            type: "success",
                        });
                        this.payLimit.isWork = isWork;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                },
            });
        },
        modifyValidate() {
            const month = parseInt(this.vipPayMounthTableData.vipMonth)
            if (isNaN(month) || month == 0) {
                this.$message.error("请输入有效的数字")
                return
            }
            this.$httpRequest.post('/api/readingOrder/modifyValidate', { modifydate: month, userId: this.seller.id }).then(res => {
                this.$message.success("操作成功")
                this.$refs.vipPayMounthTableData.getData();
            })
        }
    },
    watch: {
        seller(newVal, oldVal) {
            console.log(this.seller, newVal.oldVal)

        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/layper/user-info-layper.vue